import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';
import ProjectModel from 'models/Project';

import Link from 'next/link';
import Wrapper from './styled/Wrapper';
import Header from './styled/Header';
import Heading from './styled/Heading';
import TagValue from './styled/TagValue';
import TagSeparator from './styled/TagSeparator';
import Title from './styled/Title';
import LinksWrapper from './styled/LinksWrapper';
import StyledLink from './styled/Link';

export default class TagsSection extends PureComponent {


  static defaultProps = {
    copyCategory: 'Category',
    copyClients: 'In collaboration with',
    copyIndustry: 'Industry',
    copyGrade: 'Grade',
    copyAwards: 'Recognition',
    copyOffer: 'Capabilities',
  };

  static contextType = ThemeContext;

  onTagClick(name, value) {
    // if(appState.analytics)appState.analytics._trackEvent('TagsSection', 'click tag', `${name}: ${value}`);
  }

  renderTags(name, values, className) {
    const valuesArray = Array.isArray(values) ? values : [values];

    return (
      <Header className={className}>
        <Heading theme={this.context}>{name}</Heading>
        {valuesArray.map(value => (
          <Fragment key={`${name}-${value.name}`}>
            <TagValue
              theme={this.context}
              href={value.url}
              target="_blank"
              onClick={value.url && (() => this.onTagClick(name, value.name))}
            >
              {value.name}
            </TagValue>
            <TagSeparator>, </TagSeparator>
          </Fragment>
        ))}
      </Header>
    );
  }

  renderLinks(links, baseUrl) {
    return (
      <LinksWrapper>
        {links.map(link => (
          <Link key={link.slug} href={`${baseUrl}/${link.slug}`} passHref>
            <StyledLink theme={this.context}>{link.name}</StyledLink>
          </Link>
        ))}
      </LinksWrapper>
    );
  }

  render() {
    const {
      copyCategory,
      copyClients,
      copyIndustry,
      copyGrade,
      copyAwards,
      copyOffer,
      category,
      industries,
      grade,
      name,
      clients,
      awards,
      baseUrl,
      links,
    } = this.props;

    return (
      <Wrapper>
        {category && this.renderTags(copyCategory, category, 'category')}
        {industries && this.renderTags(copyIndustry, industries, 'industry')}
        {grade && this.renderTags(copyGrade, grade, 'grade')}
        {!category && (
          <Heading offer theme={this.context}>
            {copyOffer}
          </Heading>
        )}
        <Title id="tagTitle" theme={this.context}>{name}</Title>
        {clients && this.renderTags(copyClients, clients, 'clients')}
        {awards && awards.length > 0 && this.renderTags(copyAwards, awards, 'awards')}
        {links && this.renderLinks(links, baseUrl)}
      </Wrapper>
    );
  }
}
